import type { TResponsiveValue } from '@/utils/hooks/responsive/interfaces'

export const ResponsiveBlocksPerGrid: TResponsiveValue<number> = {
  desktop: 13,
  tablet: 8,
  mobile: 9,
}
